import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PayoutState } from './payout.reducer';
const selectPayoutState = createFeatureSelector<PayoutState>('payout');

export const selectPayoutOverview = createSelector(
  selectPayoutState,
  (state: PayoutState) => state.overview && { ...state.overview }
);
